// extracted by mini-css-extract-plugin
export default {"container":"ForgotPassword_container__sOQx+","description":"ForgotPassword_description__DK5RY"};